import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle } from 'lucide-react';

const CTA: React.FC = () => {
  const benefits = [
    '30-day free trial',
    'No credit card required',
    'Full access to all features',
    'Cancel anytime'
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-primary-600 to-primary-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Main CTA */}
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            Ready to transform your learning?
          </h2>
          <p className="text-xl md:text-2xl text-primary-100 mb-8 max-w-3xl mx-auto">
            Join thousands of educators who are already using tadriso to create 
            better learning experiences for their students.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Link
              to="/start-trial"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-primary-600 hover:bg-gray-100 font-semibold rounded-lg transition-colors duration-200"
            >
              Start Free Trial
              <ArrowRight size={20} className="ml-2" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-white hover:bg-white hover:text-primary-600 font-semibold rounded-lg transition-colors duration-200"
            >
              Schedule Demo
            </Link>
          </div>

          {/* Benefits */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-center justify-center space-x-2">
                <CheckCircle size={20} className="text-primary-200" />
                <span className="text-primary-100">{benefit}</span>
              </div>
            ))}
          </div>

          {/* Trust Indicators */}
          <div className="mt-16 pt-8 border-t border-primary-500">
            <p className="text-primary-200 mb-4">Trusted by leading institutions</p>
            <div className="flex flex-wrap justify-center items-center gap-8 opacity-60">
              <div className="text-primary-200 font-semibold">Stanford University</div>
              <div className="text-primary-200 font-semibold">MIT</div>
              <div className="text-primary-200 font-semibold">Harvard</div>
              <div className="text-primary-200 font-semibold">Yale</div>
              <div className="text-primary-200 font-semibold">UC Berkeley</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA; 